import DataPill from "@components/pills/DataPill";
import { TransactionDetails } from "@services/models/UserManagement/get-transaction";
import { useNavigate } from "react-router-dom";
import ConstantFunctions from "../../../utils/constants_functions";
import TransactionTypeSymbols from "./TransactionTypeSymbols";
import { getTransactionTypeText } from "./TransactionTypeText";

interface TransactionRowProps {
  transaction: TransactionDetails;
  path?: string;
  onRowClick?: (transactionId: number, ledger: string) => void;
  isSelected?: boolean;
}

const TransactionRowComponent: React.FC<TransactionRowProps> = ({
  transaction,
  path = "",
  onRowClick,
  isSelected = false,
}) => {
  const constantFunctions = new ConstantFunctions();
  const navigate = useNavigate();
  function sendToTransactionDetailScreen(
    transactionID: number,
    ledger: string,
  ) {
    localStorage.setItem("comingFromTransactionDetails", "true");
    navigate(`/transaction-status/${transactionID}/${ledger}`, {
      state: { path: path },
    });
  }
  return (
    <div
      className={`flex flex-row py-[20px] cursor-pointer ${
        isSelected
          ? "border-t-[1px] border-b-[1px] border-text-navbar-active"
          : "border-b border-b-border-table"
      }`}
      key={transaction.transactionId}
      onClick={
        path.startsWith("widgets/pos")
          ? () => {
              const baseUrl = window.location.origin;
              const paymentUrl = `${baseUrl}/pscreen/${transaction.orderId}`;
              window.open(paymentUrl, "_blank");
            }
          : () => {
              if (onRowClick) {
                onRowClick(transaction.transactionId, transaction.ledger);
              } else {
                sendToTransactionDetailScreen(
                  transaction.transactionId,
                  transaction.ledger,
                );
              }
            }
      }>
      {/* Time */}
      <div className="flex flex-row items-center place-content-start w-[50%]">
        <TransactionTypeSymbols
          transactionType={transaction?.transactionType ?? ""}
          ledger={transaction?.ledger ?? ""}
        />
        <div className="flex flex-col">
          <div className="flex flex-row mb-[4px] gap-[4px] items-center">
            <span className="text-text-base text-[12px] font-normal">
              {constantFunctions.timeFormatInHHMMSS(transaction.createdAt)}
            </span>
            <span className="bg-bg-base rounded-[2px] font-medium text-[8px] text-text-subtle px-[3px] py-[2px] text-center">
              {getTransactionTypeText(transaction?.transactionType ?? "")}
            </span>
          </div>
          <div className="flex flex-row gap-[4px] items-center">
            <span className="text-text-subtle text-[10px] font-normal place-content-center">
              {constantFunctions
                .dateFormatInDDMMM(transaction.createdAt)
                .toUpperCase()}
            </span>
            <span className="bg-bg-base rounded-[2px] font-medium text-[10px] text-text-subtle px-[3px] py-[2px]">
              {transaction?.ledger === "CR" ? "RECEIVED" : "SENT"}
            </span>
          </div>
        </div>
      </div>
      {/* Token */}
      <div className="flex flex-row items-center place-content-start w-[20%]">
        <img
          src={transaction.settledCurrencyImage}
          alt={transaction.settledCurrency}
          className="h-[18px] w-[18px] mr-[8px]"
        />
        <div className="flex flex-col">
          <span className="text-text-base text-[12px] font-normal mb-[4px]">
            {transaction.settledCurrency}
          </span>
          <span className="text-text-subtle text-[10px] font-normal">
            {transaction.network}
          </span>
        </div>
      </div>
      {/* Amount */}
      <div className="flex flex-col justify-end w-[30%]">
        <div className="flex items-center justify-end">
          <span className="text-text-base text-[12px] font-normal mb-[4px]">
            {constantFunctions.formatAmount(transaction.settledAmountRequested)}
          </span>
        </div>
        <div className={`flex flex-row items-center justify-end`}>
          <DataPill
            value={transaction.status}
            label={transaction.status ? undefined : "UNKNOWN"}
          />
        </div>
      </div>
    </div>
  );
};

export default TransactionRowComponent;
